// import React, { useEffect, useState } from "react";

// import { Link, useLocation, useNavigate } from "react-router-dom";

// import { API_ENDPOINT } from '../auth/config';
// import bcrypt from 'bcryptjs';
// import zooeticket from "../img/logozoo.png";
// import "./nav.css";
// import { gapi } from 'gapi-script';
// function Navbar() {
//   const location = useLocation(); // once ready it returns the 'window.location' object
//   const Name = localStorage.getItem('name')
//   const [url, setUrl] = useState(null);
//   const date = new Date();
//   const time = date.toISOString().replace(/[-:T.]/g, '').slice(0, 14); // 'YmdH' format
//   const timeWithKey = time + '@pay';
//   const saltRounds = 10;
//   const apikey = localStorage.getItem('apikey');
//   const email = localStorage.getItem('email');
//   const userid = localStorage.getItem('userid');


//   if (!apikey) {
//     bcrypt.hash(timeWithKey, saltRounds, (err, hash) => {
//       if (err) {
//         console.error('Error hashing password:', err);
//         return;
//       }

//       genApiKey(userid, hash)


//     });


//   } else {


//   }

//   const genApiKey = async (id, auth) => {


//     const url = new URL(`${API_ENDPOINT}/api/v1/zoo/public/e-member/genApiKey`);
//     url.searchParams.append("model", "web");
//     url.searchParams.append("member_id", id);
//     url.searchParams.append("time", time);
//     url.searchParams.append("auth", auth);

//     const requestOptions = {
//       method: "GET",
//       redirect: "follow"
//     };

//     try {
//       const response = await fetch(url, requestOptions);

//       if (!response.ok) {
//         throw new Error(`HTTP error! Status: ${response.status}`);
//       }

//       const result = await response.json(); // เปลี่ยนเป็น response.text() ถ้าคุณต้องการรับข้อมูลเป็นข้อความ
//       localStorage.setItem('apikey', result[0].replace(/^"|"$/g, '')); // เก็บข้อมูลใน localStorage
//       localStorage.setItem('credit', result[1].replace(/^"|"$/g, '')); // เก็บข้อมูลใน localStorage
//     } catch (error) {

//     }
//   };

//   useEffect(() => {

//     setUrl(location.pathname);
//   }, [location]);
//   const [isLoggedIn, setIsLoggedIn] = useState(false);
//   const [isGapiLoaded, setIsGapiLoaded] = useState(false);
//   const CLIENT_ID = '381801295139-qnj77qb40mfo3fi73q99fc3tq59rq6qg.apps.googleusercontent.com';
//   useEffect(() => {
//     const token = localStorage.getItem('token');

//     if (token) {
//       setIsLoggedIn(true);
//     } else {
//       setIsLoggedIn(false);
//     }
//   }, []); // Empty dependency array means this effect runs once after the initial render
//   useEffect(() => {
//     function start() {
//       gapi.client.init({
//         clientId: CLIENT_ID,
//         scope: 'profile email',
//       }).then(() => {
//         setIsGapiLoaded(true);
//       });
//     }

//     gapi.load('client:auth2', start);
//   }, []);

//   const handleSignOut = () => {
//     if (isGapiLoaded) {
//       gapi.auth2.getAuthInstance().signOut().then(() => {
//         localStorage.clear();
//         window.location.href = '/emember/';
//       });
//     } else {
//       console.error('Google API not initialized');
//     }
//   };

//   const handleLogout = () => {
//     localStorage.clear();
//     // localStorage.removeItem('token');
//     // setIsLoggedIn(false);
//     // navigate('/');
//     window.location.href = '/emember/';
//   };

//   const Logout = () => {
//     if (email === 'google') {
//       handleSignOut();
//     } else {
//       handleLogout();
//       handleSignOut();
//     }
//   };

//   // ...
//   return (
//     <div className="App">
//       {/* <!-- Navbar Start fixed-top  --> */}
//       <nav
//         className="navbar bg-body-tertiary navbar-expand-lg bg-white navbar-light py-lg-0 px-4 px-lg-5 wow fadeIn "
//         data-wow-delay="0.1s"
//         style={{ background: 'rgba(255, 255, 255, 0.60)', boxShadow: '0px 4px 26.600000381469727px rgba(0, 0, 0, 0.25)' }}>
//         <Link to="/Home" className="navbar-brand p-0">
//           <img
//             className="img-fluid me-3"
//             src={zooeticket}
//             alt="zooeticketlogo"
//           />
//         </Link>
//         <button
//           type="button"
//           className="navbar-toggler"
//           data-bs-toggle="collapse"
//           data-bs-target="#navbarCollapse"
//         >
//           <span className="navbar-toggler-icon"></span>
//         </button>
//         <div
//           className="collapse navbar-collapse py-4 py-lg-0"
//           id="navbarCollapse"
//         >
//           <div className="navbar-nav ms-auto">
//             <Link
//               to="/Home"
//               className={
//                 "nav-item fs-5 fw-light nav-link underline" +
//                 (url === "/Home" ? " active" : "")
//               }
//             >
//               หน้าหลัก
//             </Link>
//             {/* <Link
//               to="/News"
//               className={
//                 "nav-item fs-5 fw-light nav-link underline" +
//                 (url === "/News" ? " active" : "")
//               }
//             >
//               โปรโมชั่น
//             </Link> */}
//             <Link
//               to="/ZooList"
//               className={
//                 "nav-item fs-5 fw-light nav-link underline" +
//                 (url === "/ZooList" ? " active" : "")
//               }
//             >
//               รอบการแสดง
//             </Link>
//             <Link
//               to="/ZooFacebookPage"
//               className={
//                 "nav-item fs-5 fw-light nav-link underline" +
//                 (url === "/ZooFacebookPage" ? " active" : "")
//               }
//             >
//               ประชาสัมพันธ์
//             </Link>

//             <Link
//               to="https://www.addpay.co.th/service-ui/service-my-systemzoo"
//               className={
//                 "nav-item fs-5 fw-light nav-link underline" +
//                 (url === "/Checkrights" ? " active" : "")
//               }
//               target="_blank"
//               rel="noopener noreferrer"
//             >
//               กิจกรรมและข่าวสาร
//             </Link>

//             <Link
//               to="/AboutUs"
//               className={
//                 "nav-item fs-5 fw-light nav-link underline" +
//                 (url === "/" ? " active" : "")
//               }
//             >
//               เกี่ยวกับ
//             </Link>


//           </div>
//           {isLoggedIn ? (
//             <div className="navbar-nav">
//               <Link
//                 to="/addticket"
//                 className={
//                   "nav-item fs-5 fw-light nav-link underline" +
//                   (url === "/addticket" ? " active" : "")
//                 }
//               >
//                 จองตั๋วสวนสัตว์
//               </Link>
//               <Link
//                 to="/OrderList"
//                 className={
//                   "nav-item fs-5 fw-light nav-link underline" +
//                   (url === "/OrderList" ? " active" : "")
//                 }
//               >
//                 รายการจอง
//               </Link>

//             </div>

//           ) : (
//             <div className="nav-item">

//             </div>
//           )}

//           {/* d-block when sing in success */}
//           {isLoggedIn ? (
//             <div className="nav-item dropdown">
//               <Link
//                 to="#"
//                 className="nav-link fs-5 fw-light dropdown-toggle"
//                 data-bs-toggle="dropdown"
//               >
//                 Profile
//               </Link>
//               <div className="dropdown-menu rounded-0 rounded-bottom m-0">
//                 <Link to="/" className="dropdown-item fs-5 fw-light">
//                   user:{Name}
//                 </Link>
//                 <Link to="/editprofile" className="dropdown-item fs-5 fw-light">
//                   แก้ไขข้อมูลส่วนตัว
//                 </Link>
//                 <Link to="/Editpass" className="dropdown-item fs-5 fw-light">
//                   เปลี่ยนรหัสผ่าน
//                 </Link>
//                 <a
//                   onClick={Logout}
//                   className=" text-danger effect effect-signin fs-5 fw-light"
//                 >
//                   Log Out
//                 </a>
//                 {/* <button 
//               onClick={Logout}
//               className="dropdown-item fs-5 fw-light"
//             >
//               ออกจากระบบ
//             </button> */}
//               </div>
//             </div>

//           ) : (
//             <div className="nav-item">
//               <Link to="/login" className="btn btn-primary effect effect-signin fs-5 fw-light">
//                 Login
//               </Link>
//             </div>
//           )}
//           {isLoggedIn ? (
//             <div className="nav-item dropdown">
//               <a
//                 onClick={Logout}
//                 className=" text-danger effect effect-signin fs-5 fw-light"
//               >
//                 Log Out
//               </a>
//             </div>

//           ) : (
//             <div className="nav-item">

//             </div>
//           )}

//           {/* d-none when not singin */}

//         </div>
//       </nav >
//       {/* <!-- Navbar End --> */}
//     </div >
//   );
// }


// export default Navbar;



import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { API_ENDPOINT } from '../auth/config';
import bcrypt from 'bcryptjs';
import zooeticket from "../img/logozoo.png";
import { gapi } from 'gapi-script';

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600&display=swap');

  .zoo-navbar {
    position: sticky;
    top: 0;
    z-index: 1000;
    background: rgba(10, 22, 40, 0.85);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    border-bottom: 1px solid rgba(255, 255, 255, 0.07);
    box-shadow: 0 4px 32px rgba(0, 0, 0, 0.4);
    padding: 0 40px;
    height: 68px;
    display: flex;
    align-items: center;
  }

  .zoo-navbar-inner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    max-width: 1300px;
    margin: 0 auto;
  }

  /* LOGO */
  .zoo-navbar-brand img {
    height: 40px;
    width: auto;
    filter: brightness(1.8) drop-shadow(0 0 6px rgba(255,255,255,0.4));
    transition: filter 0.2s;
  }
  .zoo-navbar-brand:hover img { filter: brightness(2.2) drop-shadow(0 0 12px rgba(34,197,94,0.6)); }

  /* NAV LINKS */
  .zoo-nav-links {
    display: flex;
    align-items: center;
    gap: 4px;
    list-style: none;
    margin: 0;
    padding: 0;
  }

  .zoo-nav-link {
    text-decoration: none;
    color: #94a3b8;
    font-size: 0.875rem;
    font-weight: 400;
    padding: 8px 14px;
    border-radius: 10px;
    transition: color 0.2s, background 0.2s;
    white-space: nowrap;
  }

  .zoo-nav-link:hover {
    color: #f1f5f9;
    background: rgba(255, 255, 255, 0.06);
  }

  .zoo-nav-link.active {
    color: #22c55e;
    background: rgba(34, 197, 94, 0.1);
    font-weight: 500;
  }

  /* TICKET BUTTON (special) */
  .zoo-nav-link-ticket {
    color: #22c55e !important;
    border: 1px solid rgba(34, 197, 94, 0.3);
    background: rgba(34, 197, 94, 0.07) !important;
  }
  .zoo-nav-link-ticket:hover {
    background: rgba(34, 197, 94, 0.15) !important;
    border-color: rgba(34, 197, 94, 0.5);
  }

  /* DIVIDER */
  .zoo-nav-divider {
    width: 1px;
    height: 20px;
    background: rgba(255,255,255,0.1);
    margin: 0 8px;
  }

  /* RIGHT SECTION */
  .zoo-navbar-right {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  /* LOGIN BUTTON */
  .zoo-btn-login {
    padding: 9px 20px;
    background: linear-gradient(135deg, #22c55e, #16a34a);
    border: none;
    border-radius: 10px;
    color: #fff;
    font-size: 0.875rem;
    font-weight: 600;
    cursor: pointer;
    text-decoration: none;
    transition: transform 0.15s, box-shadow 0.15s;
    box-shadow: 0 2px 12px rgba(34, 197, 94, 0.3);
    white-space: nowrap;
  }
  .zoo-btn-login:hover {
    color: #fff;
    transform: translateY(-1px);
    box-shadow: 0 4px 20px rgba(34, 197, 94, 0.45);
  }

  /* PROFILE DROPDOWN */
  .zoo-profile-wrapper {
    position: relative;
  }

  .zoo-profile-trigger {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 7px 14px 7px 7px;
    background: rgba(255,255,255,0.05);
    border: 1px solid rgba(255,255,255,0.1);
    border-radius: 12px;
    cursor: pointer;
    transition: background 0.2s, border-color 0.2s;
    user-select: none;
  }

  .zoo-profile-trigger:hover {
    background: rgba(255,255,255,0.09);
    border-color: rgba(255,255,255,0.18);
  }

  .zoo-profile-avatar {
    width: 30px;
    height: 30px;
    border-radius: 8px;
    background: linear-gradient(135deg, #22c55e, #16a34a);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.8rem;
    font-weight: 700;
    color: #fff;
    flex-shrink: 0;
  }

  .zoo-profile-name {
    font-size: 0.85rem;
    font-weight: 500;
    color: #e2e8f0;
    max-width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .zoo-profile-chevron {
    width: 16px;
    height: 16px;
    color: #64748b;
    transition: transform 0.2s;
  }

  .zoo-profile-wrapper.open .zoo-profile-chevron { transform: rotate(180deg); }

  /* DROPDOWN MENU */
  .zoo-dropdown {
    position: absolute;
    top: calc(100% + 8px);
    right: 0;
    background: #0f172a;
    border: 1px solid rgba(255,255,255,0.1);
    border-radius: 14px;
    padding: 8px;
    min-width: 200px;
    box-shadow: 0 16px 48px rgba(0,0,0,0.5);
    opacity: 0;
    pointer-events: none;
    transform: translateY(-6px);
    transition: opacity 0.2s, transform 0.2s;
  }

  .zoo-profile-wrapper.open .zoo-dropdown {
    opacity: 1;
    pointer-events: all;
    transform: translateY(0);
  }

  .zoo-dropdown-header {
    padding: 10px 12px 12px;
    border-bottom: 1px solid rgba(255,255,255,0.07);
    margin-bottom: 6px;
  }

  .zoo-dropdown-header span {
    display: block;
    font-size: 0.7rem;
    color: #475569;
    letter-spacing: 0.05em;
    margin-bottom: 2px;
  }

  .zoo-dropdown-header strong {
    font-size: 0.9rem;
    color: #f1f5f9;
    font-weight: 500;
  }

  .zoo-dropdown-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 12px;
    border-radius: 9px;
    font-size: 0.875rem;
    color: #94a3b8;
    text-decoration: none;
    transition: background 0.15s, color 0.15s;
    cursor: pointer;
    border: none;
    background: transparent;
    width: 100%;
  }

  .zoo-dropdown-item:hover {
    background: rgba(255,255,255,0.06);
    color: #f1f5f9;
  }

  .zoo-dropdown-item.danger { color: #f87171; }
  .zoo-dropdown-item.danger:hover { background: rgba(248, 113, 113, 0.1); color: #f87171; }

  .zoo-dropdown-icon {
    width: 16px;
    height: 16px;
    opacity: 0.7;
  }

  /* HAMBURGER (mobile) */
  .zoo-hamburger {
    display: none;
    flex-direction: column;
    gap: 5px;
    cursor: pointer;
    padding: 6px;
    background: none;
    border: none;
  }
  .zoo-hamburger span {
    display: block;
    width: 22px;
    height: 2px;
    background: #94a3b8;
    border-radius: 2px;
    transition: all 0.3s;
  }

  /* MOBILE MENU */
  .zoo-mobile-menu {
    display: none;
    position: fixed;
    inset: 68px 0 0 0;
    background: rgba(10, 22, 40, 0.97);
    backdrop-filter: blur(20px);
    padding: 24px 24px 40px;
    flex-direction: column;
    gap: 4px;
    z-index: 999;
    overflow-y: auto;
    border-top: 1px solid rgba(255,255,255,0.07);
  }

  .zoo-mobile-menu.open { display: flex; }

  .zoo-mobile-link {
    text-decoration: none;
    color: #94a3b8;
    font-size: 1rem;
    font-weight: 400;
    padding: 14px 16px;
    border-radius: 12px;
    transition: color 0.2s, background 0.2s;
  }
  .zoo-mobile-link:hover, .zoo-mobile-link.active {
    color: #f1f5f9;
    background: rgba(255,255,255,0.06);
  }
  .zoo-mobile-link.active { color: #22c55e; }

  .zoo-mobile-divider {
    height: 1px;
    background: rgba(255,255,255,0.07);
    margin: 8px 0;
  }

  @media (max-width: 1024px) {
    .zoo-nav-links { display: none; }
    .zoo-hamburger { display: flex; }
    .zoo-navbar { padding: 0 20px; }
    .zoo-profile-name { display: none; }
  }
`;

function Navbar() {
  const location = useLocation();
  const Name = localStorage.getItem('name');
  const [url, setUrl] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isGapiLoaded, setIsGapiLoaded] = useState(false);
  const [profileOpen, setProfileOpen] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const date = new Date();
  const time = date.toISOString().replace(/[-:T.]/g, '').slice(0, 14);
  const timeWithKey = time + '@pay';
  const saltRounds = 10;
  const apikey = localStorage.getItem('apikey');
  const email = localStorage.getItem('email');
  const userid = localStorage.getItem('userid');
  const CLIENT_ID = '381801295139-qnj77qb40mfo3fi73q99fc3tq59rq6qg.apps.googleusercontent.com';

  if (!apikey) {
    bcrypt.hash(timeWithKey, saltRounds, (err, hash) => {
      if (!err) genApiKey(userid, hash);
    });
  }

  const genApiKey = async (id, auth) => {
    const url = new URL(`${API_ENDPOINT}/api/v1/zoo/public/e-member/genApiKey`);
    url.searchParams.append("model", "web");
    url.searchParams.append("member_id", id);
    url.searchParams.append("time", time);
    url.searchParams.append("auth", auth);
    try {
      const response = await fetch(url, { method: "GET", redirect: "follow" });
      if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
      const result = await response.json();
      localStorage.setItem('apikey', result[0].replace(/^"|"$/g, ''));
      localStorage.setItem('credit', result[1].replace(/^"|"$/g, ''));
    } catch (error) { console.error(error); }
  };

  useEffect(() => { setUrl(location.pathname); }, [location]);

  useEffect(() => {
    const token = localStorage.getItem('token');
    setIsLoggedIn(!!token);
  }, []);

  useEffect(() => {
    function start() {
      gapi.client.init({ clientId: CLIENT_ID, scope: 'profile email' })
        .then(() => setIsGapiLoaded(true));
    }
    gapi.load('client:auth2', start);
  }, []);

  // Close dropdown on outside click
  useEffect(() => {
    const handler = (e) => {
      if (!e.target.closest('.zoo-profile-wrapper')) setProfileOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const handleSignOut = () => {
    if (isGapiLoaded) {
      gapi.auth2.getAuthInstance().signOut().then(() => {
        localStorage.clear();
        window.location.href = '/emember/';
      });
    } else {
      console.error('Google API not initialized');
    }
  };

  const handleLogout = () => {
    localStorage.clear();
    window.location.href = '/emember/';
  };

  const Logout = () => {
    if (email === 'google') { handleSignOut(); }
    else { handleLogout(); handleSignOut(); }
  };

  const initials = Name ? Name.charAt(0).toUpperCase() : 'U';

  const navLinks = [
    { to: "/Home", label: "หน้าหลัก" },
    // { to: "/Thaizoorealmaps", label: "นำเที่ยว" },
    { to: "/ZooList", label: "รอบการแสดง" },
    { to: "/ZooFacebookPage", label: "ประชาสัมพันธ์" },
    { to: "https://www.addpay.co.th/service-ui/service-my-systemzoo", label: "กิจกรรมและข่าวสาร", external: true },
    { to: "/AboutUs", label: "เกี่ยวกับ" },
  ];

  return (
    <>
      <style>{styles}</style>
      <nav className="zoo-navbar">
        <div className="zoo-navbar-inner">

          {/* LOGO */}
          <Link to="/Home" className="zoo-navbar-brand" style={{ textDecoration: 'none' }}>
            <img src={zooeticket} alt="Zoo e-Ticket" />
          </Link>

          {/* DESKTOP NAV LINKS */}
          <ul className="zoo-nav-links">
            {navLinks.map(({ to, label, external }) => (
              <li key={to}>
                {external ? (
                  <a href={to} className="zoo-nav-link" target="_blank" rel="noopener noreferrer">{label}</a>
                ) : (
                  <Link to={to} className={`zoo-nav-link${url === to ? ' active' : ''}`}>{label}</Link>
                )}
              </li>
            ))}

            {isLoggedIn && (
              <>
                <li><div className="zoo-nav-divider" /></li>
                <li>
                  <Link to="/addticket" className={`zoo-nav-link zoo-nav-link-ticket${url === '/addticket' ? ' active' : ''}`}>
                    🎫 จองตั๋ว
                  </Link>
                </li>
                <li>
                  <Link to="/OrderList" className={`zoo-nav-link${url === '/OrderList' ? ' active' : ''}`}>
                    รายการจอง
                  </Link>
                </li>
              </>
            )}
          </ul>

          {/* RIGHT: PROFILE / LOGIN */}
          <div className="zoo-navbar-right">
            {isLoggedIn ? (
              <div className={`zoo-profile-wrapper${profileOpen ? ' open' : ''}`}>
                <div className="zoo-profile-trigger" onClick={() => setProfileOpen(o => !o)}>
                  <div className="zoo-profile-avatar">{initials}</div>
                  <span className="zoo-profile-name">{Name || 'ผู้ใช้งาน'}</span>
                  <svg className="zoo-profile-chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <polyline points="6 9 12 15 18 9" />
                  </svg>
                </div>

                <div className="zoo-dropdown">
                  <div className="zoo-dropdown-header">
                    <span>ล็อกอินในฐานะ</span>
                    <strong>{Name || 'ผู้ใช้งาน'}</strong>
                  </div>
                  <Link to="/editprofile" className="zoo-dropdown-item" onClick={() => setProfileOpen(false)}>
                    <svg className="zoo-dropdown-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
                    แก้ไขข้อมูลส่วนตัว
                  </Link>
                  <Link to="/Editpass" className="zoo-dropdown-item" onClick={() => setProfileOpen(false)}>
                    <svg className="zoo-dropdown-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
                    เปลี่ยนรหัสผ่าน
                  </Link>
                  <div style={{ height: '1px', background: 'rgba(255,255,255,0.07)', margin: '6px 0' }} />
                  <button className="zoo-dropdown-item danger" onClick={() => { setProfileOpen(false); Logout(); }}>
                    <svg className="zoo-dropdown-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>
                    ออกจากระบบ
                  </button>
                </div>
              </div>
            ) : (
              <Link to="/login" className="zoo-btn-login">เข้าสู่ระบบ</Link>
            )}

            {/* HAMBURGER */}
            <button className="zoo-hamburger" onClick={() => setMobileOpen(o => !o)} aria-label="Toggle menu">
              <span style={mobileOpen ? { transform: 'rotate(45deg) translate(5px, 5px)' } : {}} />
              <span style={mobileOpen ? { opacity: 0 } : {}} />
              <span style={mobileOpen ? { transform: 'rotate(-45deg) translate(5px, -5px)' } : {}} />
            </button>
          </div>
        </div>
      </nav>

      {/* MOBILE MENU */}
      <div className={`zoo-mobile-menu${mobileOpen ? ' open' : ''}`}>
        {navLinks.map(({ to, label, external }) => (
          external ? (
            <a key={to} href={to} className="zoo-mobile-link" target="_blank" rel="noopener noreferrer" onClick={() => setMobileOpen(false)}>{label}</a>
          ) : (
            <Link key={to} to={to} className={`zoo-mobile-link${url === to ? ' active' : ''}`} onClick={() => setMobileOpen(false)}>{label}</Link>
          )
        ))}

        {isLoggedIn && (
          <>
            <div className="zoo-mobile-divider" />
            <Link to="/addticket" className={`zoo-mobile-link${url === '/addticket' ? ' active' : ''}`} onClick={() => setMobileOpen(false)}>🎫 จองตั๋วสวนสัตว์</Link>
            <Link to="/OrderList" className={`zoo-mobile-link${url === '/OrderList' ? ' active' : ''}`} onClick={() => setMobileOpen(false)}>รายการจอง</Link>
          </>
        )}

        <div className="zoo-mobile-divider" />

        {isLoggedIn ? (
          <>
            <Link to="/editprofile" className="zoo-mobile-link" onClick={() => setMobileOpen(false)}>แก้ไขข้อมูลส่วนตัว</Link>
            <Link to="/Editpass" className="zoo-mobile-link" onClick={() => setMobileOpen(false)}>เปลี่ยนรหัสผ่าน</Link>
            <button
              onClick={() => { setMobileOpen(false); Logout(); }}
              style={{ background: 'none', border: 'none', textAlign: 'left', color: '#f87171', fontFamily: 'Outfit, sans-serif', fontSize: '1rem', padding: '14px 16px', borderRadius: '12px', cursor: 'pointer', width: '100%' }}
            >
              ออกจากระบบ
            </button>
          </>
        ) : (
          <Link to="/login" className="zoo-btn-login" style={{ textAlign: 'center', marginTop: '8px' }} onClick={() => setMobileOpen(false)}>เข้าสู่ระบบ</Link>
        )}
      </div>
    </>
  );
}

export default Navbar;